// extracted by mini-css-extract-plugin
export var wrapper = "VabfLogo-module--wrapper--h_HJz";
export var anim_v = "VabfLogo-module--anim_v--238lT";
export var anim = "VabfLogo-module--anim--sCxDR";
export var anim_a = "VabfLogo-module--anim_a--2kwVE";
export var anim_b = "VabfLogo-module--anim_b--oSEHM";
export var anim_f = "VabfLogo-module--anim_f--1UCsE";
export var linkLineloop = "VabfLogo-module--link-lineloop--1ZbDD";
export var keyGnav = "VabfLogo-module--key-gnav--2Li1W";